import { RefObject, useEffect, useState } from 'react'

function useIsFloaterInWrapperView(
    wrapperRef: RefObject<HTMLElement>,
    absoluteElementRef: RefObject<HTMLElement>,
    hoverElementRef: RefObject<HTMLElement>,
    gap = 0
): [{ isOverflowing: boolean }, { checkIfOverflows: () => void }] {
    const [isOverflowing, setIsOverflowing] = useState(false)

    useEffect(() => {
        checkIfOverflows()
    }, [wrapperRef, absoluteElementRef, hoverElementRef, gap])

    useEffect(() => {
        wrapperRef.current &&
            wrapperRef.current.addEventListener('scroll', checkIfOverflows)

        return () =>
            wrapperRef?.current?.removeEventListener('scroll', checkIfOverflows)
    }, [absoluteElementRef, isOverflowing, wrapperRef])

    const checkIfOverflows = () => {
        if (
            !wrapperRef.current ||
            !absoluteElementRef.current ||
            !hoverElementRef.current
        ) {
            return
        }

        const wrapperRect = wrapperRef.current.getBoundingClientRect()
        const absoluteElementRect =
            absoluteElementRef.current.getBoundingClientRect()
        const hoverElementRect = hoverElementRef.current.getBoundingClientRect()

        const shouldFloaterReturnToTop =
            wrapperRect.top <
            absoluteElementRect.top -
                absoluteElementRect.height -
                hoverElementRect.height -
                gap -
                60
        const shouldFloaterGoToBottom =
            wrapperRect.top > absoluteElementRect.top - 60

        if (isOverflowing) {
            shouldFloaterReturnToTop && setIsOverflowing(false)

            return
        }

        shouldFloaterGoToBottom && setIsOverflowing(true)
    }

    return [{ isOverflowing }, { checkIfOverflows }]
}

export default useIsFloaterInWrapperView
